import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormSelect } from 'ui/FormComponents';

const FrequencySelect: React.FC<{ showLabel?: boolean }> = ({ showLabel = false }) => {
  const { t } = useTranslation();
  const frequencyOptions = [
    'DAILY',
    'MONDAYS',
    'TUESDAYS',
    'WEDNESDAYS',
    'THURSDAYS',
    'FRIDAYS',
    'SATURDAYS',
  ].map((item) => ({
    label: t(`components:notifications_manager.frequency_options.${item}`),
    value: item,
    disabled: false,
  }));
  return (
    <FormSelect
      key="frequency"
      name="frequency"
      label={showLabel ? t(`components:notifications.form.labels.frequency`) : undefined}
      selectOptionData={frequencyOptions}
      isRequired
    />
  );
};

export default FrequencySelect;
